import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// import SIP from './utils/sipUtils'

import SIP from './utils/phone/phone'


/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'


/* add some free styles */
import { fab } from '@fortawesome/free-brands-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { loadSvg } from './icons'
import IconSvg from './components/icon-svg'
import ja from 'element-ui/lib/locale/lang/ja'
import locale from 'element-ui/lib/locale'

loadSvg();
Vue.component('icon', IconSvg);

/* add icons to the library */
library.add(fab, fas, far)

/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon)



Vue.prototype.$SIP = SIP


locale.use(ja)
window.Bus =new Vue();
import {
  Button,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Row,
  Col,
  Card,
  Switch,
  Input,
  Form,
  FormItem,
  Collapse,
  CollapseItem,
  Tabs,
  TabPane,
  Table,
  TableColumn,
  Loading,
  Avatar,
  Rate,
  Tooltip,
  Dialog,
  Checkbox,
  Scrollbar,
  Popover,
  Tag,
  Slider,
  Radio,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Progress,
  Autocomplete,
  Badge,
  Select,
  Option,
  Upload,
  DatePicker,
  Drawer,
  Message,
  Image,
  Pagination,
} from 'element-ui';
Vue.use(Button)
  .use(Container)
  .use(Header)
  .use(Aside)
  .use(Main)
  .use(Footer)
  .use(Row)
  .use(Col)
  .use(Card)
  .use(Switch)
  .use(Input)
  .use(Form)
  .use(FormItem)
  .use(Collapse)
  .use(CollapseItem)
  .use(Tabs)
  .use(TabPane)
  .use(Table)
  .use(TableColumn)
  .use(Loading.directive)
  .use(Avatar)
  .use(Rate)
  .use(Tooltip)
  .use(Dialog)
  .use(Checkbox)
  .use(Scrollbar)
  .use(Popover)
  .use(Tag)
  .use(Slider)
  .use(Radio)
  .use(Dropdown)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Progress)
  .use(Autocomplete)
  .use(Badge)
  .use(Select)
  .use(Option)
  .use(Upload)
  .use(DatePicker)
  .use(Drawer)
  .use(Image)
  .use(Pagination)

import VModal from 'vue-js-modal'
Vue.use(VModal)

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)



Vue.config.productionTip = false
Vue.config.devtools = true

Vue.prototype.$message = Message

import utils from './utils/utils'

Vue.prototype.$utils = utils

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
